export const CHECKOUT_SAVE_SHIPPING_ADDRESS =
  'checkout/CHECKOUT_SAVE_SHIPPING_ADDRESS';
export const CHECKOUT_SAVE_BILLING_ADDRESS =
  'checkout/CHECKOUT_SAVE_BILLING_ADDRESS';

export const URL_FOR_CHECKOUT_FIRST_STEP = '/checkout/address';
export const URL_FOR_CHECKOUT_PAYMENT_STEP = '/checkout/payment';
